module.exports = __webpack_public_path__ + "static/media/contact-form.73152d28.svg";